/** Types */
export const GET_ORDERS_REQUEST = 'GET_ORDERS_REQUEST';
export const GET_ORDERS_REQUEST_SUCCESS = 'GET_ORDERS_REQUEST_SUCCESS';

export const ORDERS_POST_REQUEST = 'ORDERS_POST_REQUEST';
export const ORDERS_POST_SUCCESS = 'ORDERS_POST_SUCCESS';
